module.exports = __webpack_public_path__ + "static/media/gasstation.c03d803b.jpg";